import * as React from 'react';
import MultiSelect from '../../CommonUI/Control/Multiselect';
import { css, StyleSheet } from 'aphrodite';
import { Box, Flex } from '../../CommonUI/Layout';
import { Label } from '../../CommonUI';
import { connect } from 'react-redux';
import { ConfigurationScope } from '../../Model';
import * as actions from '../../Actions/PastOrders';

interface ShopComponentProps {
    configurationScopeTree: ConfigurationScope[];
    selectedShops: string[][];
    setSelectedShops: (value: string[]) => void;
    disabled?: boolean;
}

const ShopComponent: React.SFC<ShopComponentProps> = (props) => {
    const {configurationScopeTree, setSelectedShops, selectedShops, disabled} = props;
    const options = configurationScopeTree.map((item) => ({
        label: `${item.names.store}${item.names.view ? '-' + item.names.view : ''}`,
        value: item.ids.toString(),
    }));
    return (
        <Box pl={20} pr={20} mt={0} className={css(styles.box)}>
            <Flex>
                <Label
                    label="enhancedPastOrders.selectShop"
                />
                <MultiSelect
                    value={selectedShops.map((el: string[]) => el.toString())}
                    options={options}
                    onChange={setSelectedShops}
                    disabled={disabled}
                />
            </Flex>
        </Box>
    );
};

const styles = StyleSheet.create({
    box: {
        maxWidth: '390px',
    },
});

const mapStateToProps = (state: any) => ({
    configurationScopeTree: state.App.configurationScopeTree,
    selectedShops: state.PastOrders.selectedShops,
});

const mapDispatchToProps = (dispatch: any) => ({
    setSelectedShops: (selectedShop: string[]) => dispatch(actions.setSelectedShops(selectedShop)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopComponent);
